import store from '../store';
import Constants from '../config/constants';
import {
    serviceGetUpdatedIdCardList,
} from "../services/UpdatedIdCard.service";

export const FETCH_INIT = 'FETCH_INIT_UPDATED_ID_CARD';
export const FETCHED = 'FETCHED_UPDATED_ID_CARD';
export const FETCHED_FAIL = 'FETCHED_FAIL_UPDATED_ID_CARD';
export const FETCHED_FILTER = 'FETCHED_FILTER_UPDATED_ID_CARD';
export const FETCH_NEXT = 'FETCH_NEXT_UPDATED_ID_CARD';
export const FILTER = 'FILTER_UPDATED_ID_CARD';
export const RESET_FILTER = 'RESET_FILTER_UPDATED_ID_CARD';
export const SET_SORTING = 'SET_SORTING_UPDATED_ID_CARD';
export const SET_FILTER = 'SET_FILTER_UPDATED_ID_CARD';
export const SET_PAGE = 'SET_PAGE_UPDATED_ID_CARD';
export const CHANGE_PAGE = 'CHANGE_PAGE_UPDATED_ID_CARD';
export const CHANGE_STATUS= 'CHANGE_STATE_UPDATED_ID_CARD';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_UPDATED_ID_CARD';

export function actionFetchUpdatedIdCard(index = 1, sorting = {}, filter = {}, shouldReset=false) {
    const request = serviceGetUpdatedIdCardList({ index, row: sorting.row , order: sorting.order, ...filter }); // GetIdCard
    return (dispatch) => {
        if (shouldReset) {
            dispatch({
                type: CHANGE_PAGE,
                payload: 1,
            });
        }
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: SET_FILTER, payload: filter});
            dispatch({type: SET_SORTING, payload: sorting});
            if (!data.error) {
                dispatch({type: FETCHED, payload: { data: data.data.data, page: index }});
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({type: CHANGE_PAGE, payload: index - 1});
                }
            } else {
                dispatch({type: FETCHED_FAIL, payload: null});
            }
        });
    };
}

export function actionChangePageUpdatedIdCard(page) {
    return (dispatch) => {
        dispatch({type: CHANGE_PAGE, payload: page})
    }
}

export function actionFilterUpdatedIdCard(value) {
    const request = null;////serviceFetchProviderRequests(value);
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: FILTER, payload: data});
            dispatch({type: FETCHED, payload: null});
        });
    };
}


export function actionChangeStatusUpdatedIDCard(id, status) {
    //const request = serviceUpdateUpdatedIDCard({ id: params.id, status: params.type});
    return (dispatch) => {
        dispatch({type: CHANGE_STATUS, payload: {id, status}});
    };
}

export function actionResetFilterUpdatedIDCard() {
    return {
        type: RESET_FILTER,
        payload: null,
    };
}

export function actionSetPageUpdatedIDCard(page) {
    const stateData = store.getState().updated_id_card;
    const currentPage = stateData?.currentPage;
    const totalLength = stateData?.all.length;
    const sortingData = stateData?.sorting_data;
    const query = stateData?.query;
    const queryData = stateData?.query_data;
    const startDate = stateData?.start_date;
    const endDate = stateData?.end_date;
    const serverPage = stateData?.serverPage;

    if (totalLength <= ((page + 1) * Constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(actionFetchUpdatedIdCard(serverPage + 1, sortingData, {query, query_data: queryData, start_date: startDate, end_date: endDate}));
    }

    return {
        type: CHANGE_PAGE,
        payload: page,
    };
}
